/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiatePaymentResponse
 */
export interface InitiatePaymentResponse {
    /**
     * 
     * @type {InitiatePaymentResponsePaymentStateEnum}
     * @memberof InitiatePaymentResponse
     */
    paymentState: InitiatePaymentResponsePaymentStateEnum;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentResponse
     */
    redirectUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentResponse
     */
    qrCodeData?: string;
}


/**
 * @export
 */
export const InitiatePaymentResponsePaymentStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type InitiatePaymentResponsePaymentStateEnum = typeof InitiatePaymentResponsePaymentStateEnum[keyof typeof InitiatePaymentResponsePaymentStateEnum];


/**
 * Check if a given object implements the InitiatePaymentResponse interface.
 */
export function instanceOfInitiatePaymentResponse(value: object): value is InitiatePaymentResponse {
    if (!('paymentState' in value) || value['paymentState'] === undefined) return false;
    return true;
}

export function InitiatePaymentResponseFromJSON(json: any): InitiatePaymentResponse {
    return InitiatePaymentResponseFromJSONTyped(json, false);
}

export function InitiatePaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiatePaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentState': json['paymentState'],
        'redirectUrl': json['redirectUrl'] == null ? undefined : json['redirectUrl'],
        'qrCodeData': json['qrCodeData'] == null ? undefined : json['qrCodeData'],
    };
}

export function InitiatePaymentResponseToJSON(json: any): InitiatePaymentResponse {
    return InitiatePaymentResponseToJSONTyped(json, false);
}

export function InitiatePaymentResponseToJSONTyped(value?: InitiatePaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentState': value['paymentState'],
        'redirectUrl': value['redirectUrl'],
        'qrCodeData': value['qrCodeData'],
    };
}

